import '../../styles/Input.css';

import React from 'react';

interface InputProps {
  type?: 'text' | 'email' | 'password' | 'number' | 'tel';
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  className?: string;
  autoCapitalize?: 'off' | 'on' | 'sentences' | 'words' | 'characters';
  autoComplete?: string;
  inputMode?: 'none' | 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url';
  pattern?: string;
}

const Input: React.FC<InputProps> = ({
  type = 'text',
  value,
  onChange,
  label,
  placeholder,
  required = false,
  error,
  className = '',
  autoCapitalize,
  autoComplete,
  inputMode,
  pattern,
}) => {
  return (
    <div className={`input-group ${className}`}>
      {label && (
        <label className="input-label">
          {label}
        </label>
      )}
      <input
        className={`input-field ${error ? 'input-error' : ''}`}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoCapitalize={autoCapitalize}
        autoComplete={autoComplete}
        inputMode={inputMode}
        pattern={pattern}
      />
      {error && (
        <div className="input-error-message">
          {error}
        </div>
      )}
    </div>
  );
};

export default Input; 